import { initGraphQLTada } from 'gql.tada';

import type { introspection } from './gql/admin';

export const graphql = initGraphQLTada<{
  introspection: introspection;
  scalars: { Money: number; DateTime: string };
  DateTime: string;
}>();
